import React from "react";

/** RacetrackIQ-Live! wordmark + Knight-with-IQ-saddlecloth logo. */
export const BrandLogo = ({ size = "md" }) => {
  const dim =
    size === "sm"
      ? { logo: 44, type: "text-[22px]", tag: "text-[9px]" }
      : { logo: 84, type: "text-4xl sm:text-5xl", tag: "text-[11px]" };

  return (
    <div
      className="inline-flex items-center gap-3 select-none"
      data-testid="brand-logo"
    >
      <img
        src={`${process.env.PUBLIC_URL}/logo-knight.png`}
        alt="RacetrackIQ knight logo"
        data-testid="brand-knight-logo"
        className="shrink-0 transition-transform duration-300 hover:-rotate-3 hover:scale-105"
        style={{
          height: dim.logo,
          width: "auto",
          // Black knight on a dark page: a cream rim + lime glow keeps the silhouette readable.
          filter:
            "drop-shadow(0 0 1px rgba(245,236,214,0.85)) drop-shadow(0 0 10px rgba(132,204,22,0.35))",
        }}
      />
      <div className="leading-none">
        <div
          className={`${dim.type} text-[#f5ecd6]`}
          style={{
            fontFamily: "'Instrument Serif', 'Times New Roman', serif",
            fontWeight: 400,
            letterSpacing: "-0.015em",
          }}
          data-testid="brand-wordmark"
        >
          Racetrack<em className="text-[#84cc16] not-italic font-semibold">IQ</em>
          <span
            className="ml-1 align-top text-[#84cc16]"
            style={{
              fontFamily: "'JetBrains Mono', ui-monospace, monospace",
              fontSize: "0.42em",
              letterSpacing: "0.08em",
            }}
          >
            -LIVE!
          </span>
        </div>
        <div
          className={`mt-1 ${dim.tag} uppercase tracking-[0.28em] text-stone-500`}
          style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace" }}
          data-testid="brand-tagline"
        >
          Post-time handicap engine
        </div>
      </div>
    </div>
  );
};
